import { render } from "./TariffDetailFormBlock.vue?vue&type=template&id=36a60377"
import script from "./TariffDetailFormBlock.vue?vue&type=script&lang=js"
export * from "./TariffDetailFormBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__